'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fbemitter = require('fbemitter');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeckoModalService = function () {
    _createClass(GeckoModalService, [{
        key: 'emitter',
        get: function get() {
            return GeckoModalService.emitter;
        },
        set: function set(value) {
            GeckoModalService.emitter = value;
        }
    }]);

    function GeckoModalService() {
        _classCallCheck(this, GeckoModalService);

        this.params = {
            size: 'lg',
            backdrop: true,
            keyboard: true
        };

        // Create modal event emitter (if not already created)
        if (!this.emitter) this.emitter = new _fbemitter.EventEmitter();
    }

    _createClass(GeckoModalService, [{
        key: 'open',
        value: function open(component) {
            var _this = this;

            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return new Promise(function (resolve, reject) {

                _this.emitter.emit('open', component, Object.assign({}, _this.params, params));

                _this.emitter.once('dismiss', function (data) {
                    return resolve();
                });
                _this.emitter.once('close', function (data) {
                    return resolve(data);
                });
            });
        }
    }, {
        key: 'close',
        value: function close(data) {
            return this.emitter.emit('close', data);
        }
    }]);

    return GeckoModalService;
}();

exports.default = GeckoModalService;